import React from 'react';
import { Box, Text } from 'rebass';
import ReactSelect from '../ReactSelect';
import ButtonToggle from '../Button/ButtonToggle';

type Assembly = {
  id: string;
  serialNumber: string | null;
  model: {
    name: string;
    backflowAssemblyMake: { name: string };
  } | null;
};

type IsProtected = 'UNKNOWN' | 'YES' | 'NO';

type Props = {
  assemblies: Assembly[];
  isProtected: IsProtected;
  onIsProtectedChange: (value: IsProtected) => void;
  assemblyId: string | null;
  onAssemblyIdChange: (value: string | null) => void;
};

const isProtectedOptions = [
  { value: 'YES' as IsProtected, label: 'Yes' },
  { value: 'NO' as IsProtected, label: 'No' },
  { value: 'UNKNOWN' as IsProtected, label: 'Unknown' },
];

function assemblyLabel(a: Assembly): string {
  return [
    a.model?.backflowAssemblyMake?.name,
    a.model?.name,
    a.serialNumber ? `#${a.serialNumber}` : null,
  ]
    .filter(Boolean)
    .join(' ');
}

export default function HazardAssemblyPicker({
  assemblies,
  isProtected,
  onIsProtectedChange,
  assemblyId,
  onAssemblyIdChange,
}: Props) {
  const selectedAssembly = assemblyId
    ? (assemblies
        .filter((a) => a.id === assemblyId)
        .map((a) => ({ value: a.id, label: assemblyLabel(a) }))[0] ?? null)
    : null;

  return (
    <>
      <Box>
        <Text variant="label" mb={1}>
          Protected?
        </Text>
        <ButtonToggle
          name="isProtected"
          value={isProtected}
          buttonOptions={isProtectedOptions.map((opt) => ({
            ...opt,
            onClick: () => onIsProtectedChange(opt.value),
          }))}
        />
      </Box>
      {isProtected === 'YES' && (
        <Box>
          <Text variant="label" mb={1}>
            Protecting Assembly
          </Text>
          <ReactSelect
            isClearable
            placeholder="Select assembly..."
            value={selectedAssembly}
            onChange={(opt: any) => onAssemblyIdChange(opt?.value ?? null)}
            options={assemblies.map((a) => ({
              value: a.id,
              label: assemblyLabel(a),
            }))}
          />
        </Box>
      )}
    </>
  );
}
